module.exports = __webpack_public_path__ + "static/media/lobby-card-speaker.26adab5b.svg";